(function(){
const CONFIG = window.RESTART_CONFIG;
const fmt = n => CONFIG.currency + (Math.round(n * 100) % 100 ? n.toFixed(2) : Math.round(n));
document.querySelectorAll("[data-price-main]").forEach(e => e.textContent = fmt(CONFIG.plannerPrice));
document.querySelectorAll("[data-price-bump]").forEach(e => e.textContent = fmt(CONFIG.bumpPrice));
document.getElementById("email").textContent = CONFIG.supportEmail;
const SUM = CONFIG.plannerPrice + CONFIG.bumpPrice + CONFIG.lifeosPrice + CONFIG.mealsPrice;
const P = {planner: CONFIG.plannerPrice, home: CONFIG.bumpPrice, lifeos: CONFIG.lifeosPrice, meals: CONFIG.mealsPrice, bundle: CONFIG.bundlePrice, sum: SUM, save: SUM - CONFIG.bundlePrice};
document.querySelectorAll("[data-p]").forEach(e => e.textContent = fmt(P[e.dataset.p]));
const plan = () => document.querySelector("input[name=plan]:checked").value;
const bump = document.getElementById("bump"), total = document.getElementById("total");
const upd = () => {
  const b = plan() === "bundle";
  document.getElementById("bumpBox").hidden = b;
  document.getElementById("bundleNote").hidden = !b;
  total.textContent = fmt(b ? CONFIG.bundlePrice : CONFIG.plannerPrice + (bump.checked ? CONFIG.bumpPrice : 0));
};
bump.addEventListener("change", upd);
document.querySelectorAll("input[name=plan]").forEach(r => r.addEventListener("change", upd)); upd();
document.getElementById("order").addEventListener("submit", e => {
  e.preventDefault();
  if (!CONFIG.shopDomain) { document.getElementById("previewMsg").hidden = false; return; }
  const items = plan() === "bundle" ? [CONFIG.bundleVariantId + ":1"] : [CONFIG.plannerVariantId + ":1"];
  if (plan() !== "bundle" && bump.checked) items.push(CONFIG.bumpVariantId + ":1");
  const utm = new URLSearchParams(location.search), keep = new URLSearchParams();
  ["utm_source","utm_medium","utm_campaign","utm_content","utm_term","fbclid"].forEach(k => utm.get(k) && keep.set(k, utm.get(k)));
  const qs = keep.toString();
  location.href = CONFIG.shopDomain + "/cart/" + items.join(",") + (qs ? "?" + qs : "");
});

// ---------- motion ----------
const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
// reset ring segments
(() => {
  const steps = [["1 min","Land","\"I don't need to catch up.\"","var(--good)",1],["3 min","Unload","Everything on your mind, quickly","var(--avg)",3],["2 min","What's urgent?","Due in the next 7 days","var(--surv)",2],["2 min","Drop, delay, ask","Cancel, move or get help","var(--pen)",2],["2 min","Restart","Pick today's page, first tiny step","var(--good)",2]];
  const C = 2 * Math.PI * 80, g = document.getElementById("segs"), ol = document.getElementById("rsteps");
  let acc = 0;
  steps.forEach(([m, t, d, col, min], i) => {
    const len = C * min / 10 - 3, off = C * acc / 10; acc += min;
    const c = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    c.setAttribute("cx", 100); c.setAttribute("cy", 100); c.setAttribute("r", 80); c.setAttribute("class", "seg");
    c.setAttribute("stroke", col); c.style.stroke = col;
    c.style.strokeDasharray = len + " " + (C - len); c.style.strokeDashoffset = -off;
    c.style.setProperty("--i", i);
    g.appendChild(c);
    const li = document.createElement("li"); li.style.setProperty("--i", i);
    li.innerHTML = '<span class="m" style="background:' + col + '">' + m + '</span><span><b>' + t + '</b> <span class="d">· ' + d + '</span></span>';
    ol.appendChild(li);
  });
})();
// reveal-on-scroll (only for things that start below the fold, so the page is complete at rest)
if (!reduce && "IntersectionObserver" in window) {
  const els = [...document.querySelectorAll("[data-rv]")];
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.remove("pre"); io.unobserve(e.target); } }), { threshold: .3 });
  els.forEach(el => { if (el.getBoundingClientRect().top > innerHeight) { el.classList.add("pre"); io.observe(el); } });
}
// day picker
(() => {
  const D = {
    good: { tag: "Good day", title: "Use the momentum.", img: CONFIG.images.good, alt: "Good day page, filled in", list: ["Time blocks for the big task", "Top 3 plus a planned break", "Write down today's win"] },
    avg: { tag: "Average day", title: "Today, realistically.", img: CONFIG.images.avg, alt: "Average day page, filled in", list: ["Top 3, then stop if you want", "A short \"if I have time\" list", "Brain dump for everything else"] },
    surv: { tag: "Survival day", title: "Just the basics.", img: CONFIG.images.surv, alt: "Survival day page, filled in", list: ["Take care of your body", "One small task", "One kind thing for you. It counts."] }
  };
  const box = document.getElementById("picker"), img = document.getElementById("pk-img"), panel = document.getElementById("pk-panel");
  const tabs = [...box.querySelectorAll("[role=tab]")];
  const pick = (day, focus) => {
    const d = D[day];
    tabs.forEach(t => { const on = t.dataset.day === day; t.setAttribute("aria-selected", on); t.tabIndex = on ? 0 : -1; if (on && focus) t.focus(); });
    box.style.setProperty("--pk", "var(--" + day + ")"); box.style.setProperty("--pk-t", "var(--" + day + "-t)");
    const swap = () => {
      document.getElementById("pk-tag").textContent = d.tag; document.getElementById("pk-title").textContent = d.title;
      document.getElementById("pk-list").innerHTML = d.list.map(x => "<li>" + x + "</li>").join("");
      img.src = d.img; img.alt = d.alt;
      panel.classList.remove("out"); img.classList.remove("out");
    };
    if (reduce) return swap();
    panel.classList.add("out"); img.classList.add("out"); setTimeout(swap, 220);
  };
  Object.values(D).forEach(d => { const p = new Image(); p.src = d.img; });
  tabs.forEach((t, i) => {
    t.addEventListener("click", () => pick(t.dataset.day));
    t.addEventListener("keydown", e => {
      const k = { ArrowRight: 1, ArrowLeft: -1 }[e.key]; if (!k) return;
      e.preventDefault(); pick(tabs[(i + k + tabs.length) % tabs.length].dataset.day, true);
    });
    t.tabIndex = t.getAttribute("aria-selected") === "true" ? 0 : -1;
  });
})();

// ---------- signature motion ----------
// scroll progress (tri-colour)
(() => {
  const bar = document.querySelector(".progress"); if (!bar) return;
  let t = 0; const set = () => { t = 0; const h = document.documentElement; bar.style.setProperty("--p", (h.scrollTop / Math.max(1, h.scrollHeight - innerHeight)).toFixed(4)); };
  addEventListener("scroll", () => { if (!t) t = requestAnimationFrame(set); }, { passive: true }); set();
})();
// hero depth on mouse move (desktop only)
if (!reduce && matchMedia("(pointer:fine)").matches) {
  const st = document.querySelector(".stage");
  const layers = [[".tablet", 14], [".paper", -22], [".note", 8]].map(([q, d]) => [st.querySelector(q), d]);
  st.closest("section").addEventListener("pointermove", e => {
    const r = st.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
    layers.forEach(([el, d]) => el && (el.style.translate = (x * d).toFixed(1) + "px " + (y * d).toFixed(1) + "px"));
  });
  st.closest("section").addEventListener("pointerleave", () => layers.forEach(([el]) => el && (el.style.translate = "0 0")));
}
// count-up when the comeback strip arrives
(() => {
  const wrap = document.querySelector(".cb-wrap"); if (!wrap || reduce || !wrap.classList.contains("pre")) return;
  const nums = [...wrap.querySelectorAll("[data-count]")]; nums.forEach(n => n.textContent = "0");
  new MutationObserver((m, o) => { if (wrap.classList.contains("pre")) return; o.disconnect();
    const t0 = performance.now() + 900, dur = 1100;
    const tick = now => { const k = Math.min(1, Math.max(0, (now - t0) / dur)), e = 1 - Math.pow(1 - k, 3);
      nums.forEach(n => n.textContent = Math.round(+n.dataset.count * e)); if (k < 1) requestAnimationFrame(tick); };
    requestAnimationFrame(tick);
  }).observe(wrap, { attributes: true, attributeFilter: ["class"] });
})();

// total price pop
const popTotal = () => { if (reduce) return; total.classList.remove("pop"); void total.offsetWidth; total.classList.add("pop"); };
bump.addEventListener("change", popTotal);
document.querySelectorAll("input[name=plan]").forEach(r => r.addEventListener("change", popTotal));

// product cards <-> order form
(() => {
  const cards = [...document.querySelectorAll("[data-card]")], pA = document.getElementById("planA"), pB = document.getElementById("planB");
  const set = (bundle, withBump) => { (bundle ? pB : pA).checked = true; if (!bundle && withBump !== undefined) bump.checked = withBump; upd(); popTotal(); sync(); };
  const sync = () => {
    const b = plan() === "bundle", sel = { planner: true, home: b || bump.checked, lifeos: b, meals: b };
    cards.forEach(c => { const on = sel[c.dataset.card]; c.classList.toggle("on", on); c.querySelector(".pick").setAttribute("aria-pressed", on); });
    document.getElementById("sysPick").textContent = b ? "The complete Restart System (all four)" : bump.checked ? "Planner + Home Reset" : "The Restart Planner";
    document.getElementById("sysTotal").textContent = total.textContent;
    document.getElementById("stickyTxt").innerHTML = "<b>" + (b ? "Restart System" : bump.checked ? "Planner + Home Reset" : "Restart Planner") + "</b> · " + total.textContent;
  };
  const toggle = k => {
    const b = plan() === "bundle";
    if (k === "planner") set(false);
    else if (k === "home") b ? set(false, false) : set(false, !bump.checked);
    else set(!b, b ? false : undefined);
  };
  cards.forEach(c => c.addEventListener("click", e => { if (e.target.closest("a")) return; toggle(c.dataset.card); }));
  bump.addEventListener("change", sync);
  document.querySelectorAll("input[name=plan]").forEach(r => r.addEventListener("change", sync));
  sync();
})();

// sticky bar after hero
const sticky = document.getElementById("sticky"), hero = document.querySelector(".hero"), offer = document.getElementById("offer");
let pastHero = false, atOffer = false;
const show = () => { const on = pastHero && !atOffer; sticky.classList.toggle("show", on); sticky.setAttribute("aria-hidden", String(!on)); };
new IntersectionObserver(([en]) => { pastHero = !en.isIntersecting; show(); }).observe(hero);
new IntersectionObserver(([en]) => { atOffer = en.isIntersecting; show(); }, { threshold: .15 }).observe(offer);
})();
